import { Controller } from '@hotwired/stimulus';
import { Editor } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import { Color, TextStyle } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';

/**
 * TipTapEditor 表示側
 */
export default class extends Controller<HTMLDivElement> {
  static override targets: string[] = ['content'];

  static override values = {
    initial: String,
  };

  declare readonly contentTarget: HTMLDivElement;

  // HTMLの方にdata-rich-text-viewer-initial-value="..."を指定することで取得できる
  declare readonly initialValue?: string;

  private editor: Editor | undefined;

  override connect(): void {
    const initialContent = this.initialValue ?? '';

    // 編集部分の描画はControllerから行われるため、スタイルはここで定義する必要がある
    const editorClass = 'min-h-60 focus:outline-none rich-text';

    /**
     * Editorの初期値について
     * @link https://tiptap.dev/docs/editor/api/editor
     */
    this.editor = new Editor({
      element: this.contentTarget,
      extensions: [
        StarterKit,
        TextStyle,
        Color,
        Link.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
      ],
      injectCSS: true,
      editorProps: {
        attributes: {
          class: editorClass,
        },
      },
      content: initialContent,
      editable: false, // 編集不可
      enableInputRules: false, // 入力規則を無効化
      enablePasteRules: false, // 貼り付け規則を無効化
    });
  }

  override disconnect(): void {
    this.editor?.destroy();
    this.editor = undefined;
  }
}
